import { render, staticRenderFns } from "./SeparatorYellow.vue?vue&type=template&id=5d07a8c1&"
import script from "./SeparatorYellow.vue?vue&type=script&lang=js&"
export * from "./SeparatorYellow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports